<template>
    <div class="product-item" :class="{active:show_flag}">
        <!-- 产品介绍 -->
        <div class="info">
            <img v-loading='img' :src="img" alt="">
            <div class="title">
                <div class="name">{{ data_list.category_name }}</div>

                <div class="other">{{ data_list.price_desc}}</div>
            </div>
            <div class="control-btn" :class="{active:show_flag}" @click="show_flag = !show_flag">
                {{ btn_text }}
                <i class="el-icon-arrow-up"></i>
            </div>
        </div>

        <!-- 表格部分 -->
        <div class="detail">
            <div v-loading='loadingshow.productFrontUrl' class="line">
                <div class="item">前台URL</div>
                <div class="item">
                    <div v-if="!inputshow['productFrontUrl']">{{data_list.ecsProduct.productFrontUrl}}</div>
                    <el-input 
                    v-if="inputshow['productFrontUrl']"
                        size="mini"
                        v-model="infodata.ecsProduct.productFrontUrl" 
                        placeholder="请输入新的前台URL" 
                        >
                    </el-input>
                </div>
                <!-- <div class="control">
                    <div v-if="!inputshow['productFrontUrl']"  @click="edit('productFrontUrl')" class="font-btn normal">
                        修改
                    </div>
                    <div v-if="inputshow['productFrontUrl']" @click="keep('productFrontUrl')"  class="font-btn danger">
                        保存
                    </div>
                </div> -->
            </div>

            <div v-loading='loadingshow.productBackUrl' class="line">
                <div class="item">后台URL</div>
                <div class="item">
                    <div v-if="!inputshow['productBackUrl']">{{data_list.ecsProduct.productBackUrl}}</div>
                    <el-input 
                    v-if="inputshow['productBackUrl']"
                        size="mini"
                        v-model="infodata.ecsProduct.productBackUrl" 
                        placeholder="请输入新的后台URL" 
                        >
                    </el-input>
                </div>
                <!-- <div class="control">
                    <div v-if="!inputshow['productBackUrl']" @click="edit('productBackUrl')"  class="font-btn normal">
                        修改
                    </div>
                    <div v-if="inputshow['productBackUrl']" @click="keep('productBackUrl')"  class="font-btn danger">
                        保存
                    </div>
                </div> -->
            </div>

            <div  v-loading='loadingshow.productPushApi' class="line">
                <div class="item">产品API</div>
                <div class="item">
                <div v-if="!inputshow['productPushApi']">{{data_list.ecsProduct.productPushApi}}</div>
                    <el-input 
                    v-if="inputshow['productPushApi']"
                        size="mini"
                        v-model="infodata.ecsProduct.productPushApi" 
                        placeholder="请输入新的产品API" 
                        >
                    </el-input>
                </div>
                <!-- <div class="control">
                    <div v-if="!inputshow['productPushApi']"  @click="edit('productPushApi')"  class="font-btn normal">
                        修改
                    </div>
                    <div v-if="inputshow['productPushApi']" @click="keep('productPushApi')"  class="font-btn danger">
                        保存
                    </div>
                </div> -->
            </div>

            <div class="line">
                <div class="item">App ID</div>
                <div class="item">
                    <div>{{data_list.ecsProduct.appid}}</div>
                    <input v-show="false">
                </div>
                <div class="item">App Secret</div>
                <div class="item">
                    <div>{{data_list.ecsProduct.appsecret}}</div>
                    <input v-show="false">
                </div>
                <!-- <div class="control">
                    <div @click="openapp(0)" v-if="data_list.ecsProduct.appstatus=='2'" class="font-btn normal">启用</div>
                    <div @click="openapp(2)" v-else-if="data_list.ecsProduct.appstatus=='0'" class="font-btn danger">停用</div>
                    <div @click="reset" class="font-btn normal">重置</div>
                </div> -->
            </div>

        </div>

    </div>
</template>

<script>
export default {
    props:{
        data_list:{},  // 数据源
    },

    data(){
        return {
            show_flag:false,        // 控制展开
            value:'',
            inputshow:{             // 修改和保存控制
            productFrontUrl:false,
            productBackUrl:false,
            productPushApi:false,
            },
            loadingshow:{
            productFrontUrl:false,
            productBackUrl:false,
            productPushApi:false,
            },
            infodata:{},
            img:''
        }
    },
    created(){
        this.infodata=JSON.parse(JSON.stringify(this.data_list))
        this.getlogo()
        
    },
    computed:{
        // 控制按钮文本
        btn_text(){
            return this.show_flag?'收起':'展开'
        },
    },
    methods:{
        // 点击修改按钮，对应的出现input框
        edit(num){
            this.inputshow[num]=true;
        },
        //修改方法，修改方法参数必穿，所以通过传参判断修改哪个。
        keep(num){
            this.loadingshow[num]=true;
            let url=`/api/supplier/app/edit`
            this.$http.post(url,{},{
                params:{
                            product_id:this.infodata.ecsProduct.id,
                            service_id:this.infodata.ecsProduct.kfProductKey,
                            front_url:num=='productFrontUrl'?this.infodata.ecsProduct.productFrontUrl:this.data_list.ecsProduct.productFrontUrl,
                            back_url:num=='productBackUrl'?this.infodata.ecsProduct.productBackUrl:this.data_list.ecsProduct.productBackUrl,
                            push_api:num=='productPushApi'?this.infodata.ecsProduct.productPushApi:this.data_list.ecsProduct.productPushApi
                        }

            })
            .then(res=>{
                if(res.code=='200'){
                    this.$set(this.data_list.ecsProduct,num,this.infodata.ecsProduct[num])
                    this.successTip('修改成功!')
                }else{
                    this.errorTip('修改失败!')
                }
                this.loadingshow[num]=false;
            })
            this.inputshow[num]=false;
        },
        //获取产品LOGO方法
        getlogo(){
            let url=`/api/supplier/product/logo/get`
            this.$http.get(url,{
                params:{
                    product_key:this.infodata.ecsProduct.kfProductKey
                },
                responseType: 'blob'
            })
            .then(res => {
                 let url = window.URL.createObjectURL(res)
                 this.img=url
            })
        },
        //重置方法，绑定父组件弹框触发按钮
        reset(){
            this.$emit('resetopen',this.data_list)
        },

        //开通按钮方法。
        openapp(status){
            let url=`/api/supplier/app/status/modify`
            this.$http.post(url,{},{
                params:{
                    product_id:this.infodata.ecsProduct.id,
                    app_id:this.infodata.ecsProduct.appid,
                    status:status
                },
            })
            .then(res=>{
                if(res.code=='200'){
                    this.data_list.ecsProduct.appstatus= status==0?'0':'2'
                    this.successTip('操作成功')
                }else{
                    this.errorTip('操作失败')
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
    @table_control_w: 56px;
    @table_first_w:120px;
    @h:40px;  // table 条目高
    @base_h:90px; // 收起时高度
    @ani_time:0.5s;  // 展开动画时间

    .product-item{
        margin: 0 @g_padd;
        max-height: @base_h;
        padding: 0 24px 32px 88px;
        box-shadow: 0 0  0 1px rgba(205,209,212,1);
        overflow: hidden; 
        transition: @ani_time;
        &+.product-item{
            margin-top: @g_padd;
        }
        &.active{
            max-height: 500px;
            box-shadow:0px 2px 5px 0px rgba(0,0,0,0.15);
        }
    }

    // 产品介绍
    .info{
        position: relative;
        padding: 16px 0;
        padding-right: 100px;
        height: @base_h;

        // 产品图片
        >img{
            height: 60px;
            width: 60px;
            background: #ccc;
            display: block;
            position: absolute;
            left:-12px;
            top:50%;
            transform: translate(-100% , -50%);
        }

        // 产品名称
        .title{
            margin-top: 4px;
            >div{
                display: inline-block;
            }
            .name{
                font-size: 16px;
                margin-right: 16px;
            }
            .other{
                font-size: 14px;
                margin-right: 16px;
            }
        }

        // 产品简介
        .introduce{
            color:#595959;
            font-size: 14px;
            margin-top: 8px;
        }

        // 控制按钮
        .control-btn{
            position: absolute;
            border: 1px solid @g_blue;
            color:@g_blue;
            font-size:14px;
            padding:0 8px;
            height:28px;
            line-height: 26px;
            border-radius:2px;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            transition: 0.3s;

            i{
                transition:  @ani_time;
                transform: rotate(180deg);
            }
            &:hover{
                background:rgba(22,163,255,0.2);
            }

            &.active{
                i{
                    transform: rotate(00deg);
                }
            }
        }

    }

    // 表格区域
    .detail{
        border:1px solid @g_border_c;
        border-bottom: 0;
        .line{
            line-height: @h - 1;
            position: relative;
            padding-right:0;
            text-align: center;
            .clear();
            .item{
                float:left;
                font-size: 14px;
                height: @h;
            }
            .item,.control{
                border-bottom: 1px solid @g_border_c;
            }
            .btngrounp{
                display: inline-block;
                height:100%;
                width: @table_control_w;
            }
        }

        .item:nth-child(2n+1){
            width:@table_first_w;
        }
        .item:nth-child(2n){
            width:calc(~"100% - @{table_first_w}");
            text-align: left;
            padding-left: 16px;
            border-left: 1px solid @g_border_c;
            border-right: 1px solid @g_border_c;
            >div{
                display: inline-block;
                width: 40%;
            }
            .el-input{
                transition: 0.3s;
                width: 40%;
            }
        }
        .control{
            font-size: 12px;
            position: absolute;
            right: 0;
            top:0;
            width:@table_control_w;
            height:100%;
        }


    }

</style>
